import { DialogContent, DialogTitle } from "@mui/material";
import { Form } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNullifyReasons, nullifyForm } from "../../../actions/forms";
import { StyledDialog } from "../../styled/dialog";
import ConfirmDialog from "../dialog/confirmDialog";
import CustomDialog from "../dialog/customDialog";
import FormikActions from "../formik/formikActions";
import FormikForm from "../formik/formikForm";
import NullifyForm from "./NullifyForm";
import { nullifyFormValidation } from "./validation";

const initialValues = {
  motivoAnulacion: null,
  observaciones: "",
}


const NullifyFormContainer = ({ open, handleClose, idArt, idForm, idSiniestro, callback }) => {
  const dispatch = useDispatch();
  const nullifyFormState = useSelector((state) => state.forms.nullifyForm);
  const [openConfirm, setOpenConfirm] = useState();
  const [postFormValues, setPostFormValues] = useState();
  const [formValues, setFormValues] = useState({});

  const [firstTimeLoading, setFirsTimeLoading] = useState({
    motivoAnulacion: false,
  });
  const isLoading = !Object.keys(firstTimeLoading).every((v) => firstTimeLoading[v] === true);

  useEffect(() => {
    if (idArt) {
      dispatch(getNullifyReasons(idArt)).finally(() => {
        setFirsTimeLoading((prevState) => ({
          ...prevState,
          motivoAnulacion: true,
        }));
      });
    }
  }, [idArt]);

  useEffect(() => {
    if (!isLoading) {
      setFormValues(initialValues);
    }
  }, [isLoading]);

  const handleSubmitNullifyForm = () => {
    const postValues = {
      wriId: idArt,
      accidentId: idSiniestro,
      formId: idForm,
      nullifyReasonId: postFormValues.motivoAnulacion,
      observations: postFormValues.observaciones,
    };
    dispatch(nullifyForm(postValues)).then(() => {
      if (callback) callback();
      setOpenConfirm(false);
      handleClose();
    })
  };

  const handleOpenConfirmNullifyForm = (values) => {
    setPostFormValues(values);
    setOpenConfirm(true);
  }

  return (
    <>
      <CustomDialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          Anulación de Formulario
        </DialogTitle>
        <FormikForm
          initialValues={formValues}
          enableReinitialize
          onSubmit={handleOpenConfirmNullifyForm}
          validationSchema={nullifyFormValidation}
        >
          {({ values, setFieldValue }) => (
            <Form>

              <DialogContent >
                <StyledDialog.Container>
                  <NullifyForm />
                </StyledDialog.Container>
              </DialogContent>
              <StyledDialog.Actions>
                <FormikActions
                  handleCancel={handleClose}
                  submitText="Anular Formulario"
                  disabled={isLoading}
                />
              </StyledDialog.Actions>
            </Form>
          )}
        </FormikForm>
      </CustomDialog>
      <ConfirmDialog
        open={openConfirm}
        handleClose={() => setOpenConfirm(false)}
        title="¿Está seguro que desea anular este formulario?"
        text="Al hacerlo, el mismo ya no será accesible desde el Siniestro"
        warningText="Advertencia: Esta acción no se podrá revertir."
        handleConfirm={() => handleSubmitNullifyForm()}
        loading={nullifyFormState.isFetching}
      />
    </>
  );
}

export default NullifyFormContainer;